export function initServices() {
    const sticky = document.querySelector( '.services__sticky' );
    if ( ! sticky ) return;

    const update = () => {
        const top = ( window.innerHeight - sticky.offsetHeight ) / 2;
        sticky.style.top = Math.max( 0, top ) + 'px';
    };

    update();
    window.addEventListener( 'resize', update );
}
